export enum CustomFieldTypes {
    String = 1,
    Currency,
    Number,
    Date,
    TextArea,
    Boolean,
    List,
    MultipleSelectionList
}
